import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { TermsAndConditionsDialogComponent } from '@shared/components/terms-and-conditions-dialog/terms-and-conditions-dialog.component';

@Injectable({
	providedIn: 'root'
})
export class TermsAndConditionsService {

	constructor (
		private _http: HttpClient,
		private _dialog: MatDialog,
		private _sanitizer: DomSanitizer,
	) { }

	displayTermsAndConditionsDialog(useAccept: boolean = false): void {
		this._http.get('./branding/html/terms-and-conditions-dialog.html', { responseType: 'text' }).subscribe({
			next: (html: string) => {
				if (html) {
					const safeHtmlTermsAndConditions = this._sanitizer.bypassSecurityTrustHtml(html);
					this._dialog.open(TermsAndConditionsDialogComponent, { data: { safeHtmlContent: safeHtmlTermsAndConditions, useAccept: useAccept } });
				}
			}
		});
	}
}
